module.exports = __webpack_public_path__ + "img/Bodice-Front-B11-Da-Ea.a6336fd8.png";